export default __webpack_public_path__ + "img/3517cb5b42917b566d53b2eea42b5609.svg";